import { useGetAddonsDataQuery } from '@/src/api/rtkQuery/addonsApi'
import useGetItineraryId from '@/src/hooks/itinerary/useGetItineraryId'

export const useAddonsApi = ({ skip }: { skip: boolean }) => {
    const itineraryId = useGetItineraryId()
    useGetAddonsDataQuery(
        {
            itineraryId
        },
        {
            skip,
            selectFromResult: () => ({})
        }
    )
}

export default useAddonsApi
